export default "__VITE_ASSET__f38d82e5__"